import React from "react";
import "./ProductWelcome.css";
import { Container, Col, Row } from "react-bootstrap";
import ReadMore from "../../CommonUI/ReadMoreBtn/ReadMore";
import StartImg from "../../../Images/start-trading.png";
function ProductWelcome() {
  return (
    <>
      <section className="product-welcome">
        <Container>
          <Row>
            <Col md={6}>
              <h2>Start trading right away!</h2>
              <p>
              Experience the New World of online trading with Fast & stable Trading Platform.
              </p>
            </Col>
            <Col md={6}>
              <img
                className="img-fluid start-trading-img"
                src={StartImg}
                alt="StartImg"
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default ProductWelcome;
